import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '../../interfaces/user';
import { UserIdleService } from 'angular-user-idle';
import { Subscription } from 'rxjs';
import { ConfigService } from './../config/config.service';
import { NgxToastrService } from '../ngx-toastr/ngx-toastr.service';
import { ReporteriaService } from '../http/reporteria/reporteria.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IAuth } from '../../interfaces/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private subscriptions: Subscription[] = [];
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private userIdle: UserIdleService,
    private ngxToastrService: NgxToastrService,
    private reporteriaService: ReporteriaService,
    private router: Router,
    private httpClient: HttpClient,
    private config: ConfigService
  ) { }

  async login(data: IAuth): Promise <any> {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/Auth/AutenticarCliente`;
    const rutCliente = parseInt(data['rutCliente'], 10);
    const auth = { rutCliente, clave: data['clave'] };

    try {
      return await this.httpClient.post(url, auth, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async parametrosTotem(): Promise<any> {
    const config = await this.config.getConfig();
    const url = `${config['totem']}/TotemInfo`;

    try {
      return await this.httpClient.get(url, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async envioClaveCliente(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/Auth/EnvioClaveCliente`;
    const rut = parseInt(data['rut'], 10);
    const opcionEnvio = parseInt(data['opcionEnvio'], 10);
    const userData = { rut, opcionEnvio };

    try {
      return await this.httpClient.post(url, userData, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async cambiarClave(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/Auth/CambioClave`;
    const rutCliente = parseInt(data['rutCliente'], 10);
    const userData = { rutCliente, clave: data['clave'] };

    try {
      return await this.httpClient.post(url, userData, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async obtenerClave(rut: string) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/Auth/ObtenerOpcionesRecuperacionClave?rut=${rut}`;

    try {
      return await this.httpClient.get(url).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async leerCliente(rut: string) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/Auth/LeerCliente?rut=${rut}`;

    try {
      const response = await this.httpClient.get(url).toPromise();
      const status = response['status'];
      if (status) {
        const userInfo = response['data'];
        this.setSession(userInfo['datosCliente'], 'leerCliente');
        return response;
      } else {
        const errorMessage = response['message'];
        return response;
      }
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  isLogged(): boolean {
    if (localStorage.getItem('login') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  setSession(data: IUser, metodo: string): void {
    if (metodo === 'login') {
      localStorage.setItem('cbLogin', 'true');
      localStorage.setItem('cbRutCliente', data['rutCliente']);
    } else {
      localStorage.setItem('cbRutCliente', data['rutCliente']);
      localStorage.setItem('cbDigRut', data['digRut']);
      localStorage.setItem('cbNombre', data['nombre']);
      localStorage.setItem('cbApeliidoPaterno', data['apellidoPaterno']);
      localStorage.setItem('cbApeliidoMaterno', data['apellidoMaterno']);
    }
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['']);
  }

  idleUser() {
    this.userIdle.startWatching();

    this.subscriptions.push(this.userIdle.onTimerStart().subscribe(count => {
      const eventList = [
        'click', 'mouseover', 'keydown', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'keyup'
      ];
      eventList.map((event => {
        document.body.addEventListener(event, () => this.userIdle.resetTimer());
      }));
    }));

    this.subscriptions.push(this.userIdle.onTimeout().subscribe(() => {
      if (this.router.url !== '/') {
        this.userIdle.resetTimer();
        this.userIdle.stopTimer();
        this.userIdle.stopWatching();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.ngxToastrService.error('Su sesión ha caducado por inactividad');
        this.reporteUsabilidad('Tótem', 'Cierre de sesión por inactividad', true);
        this.logout();
      }
    }));
  }

  reporteUsabilidad(recurso: string, respuesta: string, status: boolean) {
    if (localStorage.getItem('cbRutCliente') !== null) {
      const rut = localStorage.getItem('cbRutCliente') + '-' + localStorage.getItem('cbDigRut');

      this.reporteriaService.saveLog(
        'Tótem',
        recurso,
        respuesta,
        'Front-End',
        status,
        rut
      );
    }
  }
}
